var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_2184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_2184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V15H15V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_2184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7801 0H3.2199C1.4416 0 0 1.4416 0 3.2199V11.7801C0 13.5584 1.4416 15 3.2199 15H11.7801C13.5584 15 15 13.5584 15 11.7801V3.2199C15 1.4416 13.5584 0 11.7801 0Z",
    fill: "#AB9FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46524 9.74767C5.87627 10.6501 4.88935 11.7922 3.57612 11.7922C2.95532 11.7922 2.3584 11.5367 2.3584 10.4265C2.3584 7.59928 6.2185 3.22266 9.80005 3.22266C11.8375 3.22266 12.6494 4.63627 12.6494 6.24157C12.6494 8.30209 11.3122 10.6581 9.9831 10.6581C9.56127 10.6581 9.35434 10.4265 9.35434 10.0591C9.35434 9.96331 9.37026 9.85948 9.4021 9.74767C8.94844 10.5224 8.07295 11.2411 7.25317 11.2411C6.65625 11.2411 6.35381 10.8658 6.35381 10.3387C6.35381 10.147 6.3936 9.94733 6.46524 9.74767ZM11.3045 6.18586C11.3045 6.65363 11.0285 6.88752 10.7198 6.88752C10.4064 6.88752 10.1351 6.65363 10.1351 6.18586C10.1351 5.71809 10.4064 5.48421 10.7198 5.48421C11.0285 5.48421 11.3045 5.71809 11.3045 6.18586ZM9.55039 6.18588C9.55039 6.65366 9.2744 6.88754 8.96567 6.88754C8.65227 6.88754 8.38096 6.65366 8.38096 6.18588C8.38096 5.71811 8.65227 5.48423 8.96567 5.48423C9.2744 5.48423 9.55039 5.71811 9.55039 6.18588Z",
    fill: "#FFFDF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_2184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.2acc96eedfe594d8cb75e739a29e7ba3.svg";
export { ForwardRef as ReactComponent };